import type { SVGProps } from "react";

/**
 * Refraction marks — Concept B. A vertical rhombus split down the axis;
 * violet on the left, cyan on the right, hairline seam in bg color.
 * Reads as prism / duality of design + engineering.
 *
 * Treatments: Primary (dual gradient), MonoLight, MonoDark, Accent.
 * Source of truth: tasks/BRAND_IDENTITY.md §3.
 */

type MarkProps = Omit<SVGProps<SVGSVGElement>, "viewBox">;

export function RefractionPrimary({ titleId = "refract-primary-title", ...props }: MarkProps & { titleId?: string }) {
  const leftId = `${titleId}-left`;
  const rightId = `${titleId}-right`;
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} {...props}>
      <title id={titleId}>NEXIRT</title>
      <defs>
        <linearGradient id={leftId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#9B7FFF" />
          <stop offset="1" stopColor="#5B3EDB" />
        </linearGradient>
        <linearGradient id={rightId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#22D3EE" />
          <stop offset="1" stopColor="#0EA5C7" />
        </linearGradient>
      </defs>
      <polygon points="32,6 8,32 32,58" fill={`url(#${leftId})`} />
      <polygon points="32,6 56,32 32,58" fill={`url(#${rightId})`} />
      <line x1="32" y1="6" x2="32" y2="58" stroke="#0A0B10" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function RefractionMonoLight(props: MarkProps) {
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="NEXIRT" {...props}>
      <polygon points="32,6 8,32 32,58" fill="#F5F5F5" />
      <polygon points="32,6 56,32 32,58" fill="#F5F5F5" />
      <line x1="32" y1="6" x2="32" y2="58" stroke="#0A0B10" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function RefractionMonoDark(props: MarkProps) {
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="NEXIRT" {...props}>
      <polygon points="32,6 8,32 32,58" fill="#0A0B10" />
      <polygon points="32,6 56,32 32,58" fill="#0A0B10" />
    </svg>
  );
}

export function RefractionAccent(props: MarkProps) {
  return (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="NEXIRT" {...props}>
      <polygon points="32,6 8,32 32,58" fill="#6B4FE6" />
      <polygon points="32,6 56,32 32,58" fill="#6B4FE6" />
    </svg>
  );
}
